export function shortRevisionId(id: string): string {
  const separator = id.indexOf("-");
  return separator === -1 ? id : id.slice(0, separator);
}
